import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownAlisaTextChange } from '../../api';
import { ShutdownField } from '../../../common/ui/ShutdownField';
import { fieldNames } from '../../../common/config';
import { useAutoResponseEventsSubscription } from '../../../common/lib/autoResponseTemplateEventsSubscription';

const ModalContainer = ({ form, renderAction, renderOptionActions }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const { change, loading } = useShutdownAlisaTextChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const data = { value: formValues[fieldNames.alisaText].trim() };
        await change({ shutdownId: shutdown.alertId, data });
        close();
      }
    });
  };

  const visible = type === modalTypes.changeShutdownAlisaText;
  useAutoResponseEventsSubscription({ form, visible });

  return (
    <Modal
      visible={visible}
      onCancel={close}
      onOk={handleSubmit}
      title={`${shutdown.alisaText ? 'Изменить' : 'Добавить'} текст`}
      destroyOnClose
      confirmLoading={loading}
    >
      <Form colon={false}>
        <ShutdownField
          name={fieldNames.alisaTemplate}
          form={form}
          renderAction={renderAction}
          renderOptionActions={renderOptionActions}
        />
        <ShutdownField
          name={fieldNames.alisaText}
          form={form}
          initialValue={shutdown.alisaText}
          editMode
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_alisa_text' })(
  ModalContainer
);

export default ChangeModal;
